import React, { ReactNode } from 'react';
import InfoIcon from '@atlaskit/icon/glyph/info';
import Tooltip from '@atlaskit/tooltip';
import classNames from 'classnames';
import { LINE_ITEMS_TABLE_HEADER_NAMES } from '@css-xp/ppc-constants';
import { SearchResultColumn } from '../search-results-table';
import { FormattedCurrencyV2 } from '../formattedV2';
import { NoDataContentInTable } from '../no-data-content-table';
import './dst-line-item.scss';

interface Props {
  totalExTax?: number;
  totalIncTax?: number;
  currency?: string | null;
  taxRate?: ReactNode;
  tableHeaders: SearchResultColumn[]; // tableHeaders prop is used to get the correct order of CELLS
  hideCurrencyCode?: boolean;
  showCommas?: boolean;
  className?: string;
}

export const DSTLineItem = ({
  totalExTax,
  totalIncTax,
  currency,
  taxRate,
  tableHeaders,
  hideCurrencyCode = false,
  showCommas = false,
  className,
}: Props) => {
  const rowCells = tableHeaders?.map((header) => {
    let rowContent = <NoDataContentInTable />;

    if (
      header.name === LINE_ITEMS_TABLE_HEADER_NAMES.DETAILS ||
      header.name === LINE_ITEMS_TABLE_HEADER_NAMES.SUBSCRIPTION
    ) {
      rowContent = <span className="admin-fee">Administration Fee (DST)</span>;
    }

    if (
      header.name === LINE_ITEMS_TABLE_HEADER_NAMES.LIST_PRICE ||
      header.name === LINE_ITEMS_TABLE_HEADER_NAMES.AMOUNT_EXCL_TAX
    ) {
      rowContent = (
        <FormattedCurrencyV2
          value={totalExTax}
          currency={currency}
          showCurrencyCode={!hideCurrencyCode}
          showCommas={showCommas}
        />
      );
    }

    if (header.name === LINE_ITEMS_TABLE_HEADER_NAMES.AMOUNT_INCL_TAX) {
      rowContent = (
        <>
          <FormattedCurrencyV2
            value={totalIncTax}
            currency={currency}
            showCurrencyCode={!hideCurrencyCode}
            showCommas={showCommas}
          />
          {taxRate && (
            <span data-testid="tax-tooltip" className="tax-tooltip">
              <Tooltip content={taxRate} position="bottom-start" tag="span">
                <InfoIcon size="small" label="pending-invoice-info" />
              </Tooltip>
            </span>
          )}
        </>
      );
    }

    return <td key={header.name}>{rowContent}</td>;
  });

  return (
    <tr className={className || 'dst-line-item grey-row'} data-testid="dst-lineitem">
      {rowCells}
    </tr>
  );
};
